<template>
    <table class="table is-hoverable is-bordered is-fullwidth">
        <tbody>
            <tr v-for="competitor in podiumCompetitors" :key="competitor.id">
                <td>{{ competitor.place }}</td>
                <td class="clarity-mask">{{ competitor.firstName }} {{ competitor.lastName }}</td>
                <td>{{ competitor.academy }} / {{ competitor.branch }}</td>
            </tr>
        </tbody>
    </table>
</template>

<script setup lang="ts">
    import { computed } from "vue";
    import { StandardCategoryPodium } from "../../Api/competitorResultsApi";
    import { CompetitorWithPlace } from "../../Common/Competitors/types";

    const props = defineProps<{
        categoryPodium: StandardCategoryPodium;
    }>();

    const podiumCompetitors = computed<CompetitorWithPlace[]>(() => {
        return Object.keys(props.categoryPodium.competitors)
            .map(placeNumber => {
                const competitor = props.categoryPodium.competitors[placeNumber];
                return { ...competitor, place: parseInt(placeNumber, 10) };
            })
            .sort((a, b) => a.place - b.place);
    });
</script>
